export default __webpack_public_path__ + "static/media/gitaar-1.c2234eaa.png";